import { cn } from '@repo/videa-components/src/lib/utils';

import { SelectedOverlay } from './SelectedOverlay';

type SelectableImageCardProps = {
  children: React.ReactNode;
  className?: string;
  checked: boolean;
  onChange: () => void;
};

export const SelectableImageCard = ({
  children,
  className,
  checked,
  onChange,
}: SelectableImageCardProps) => {
  return (
    <label
      className={cn(
        'vai-relative vai-border vai-rounded-md vai-overflow-hidden vai-cursor-pointer vai-transition vai-border-slate-200',
        checked &&
          'vai-border-2 vai-border-primary vai-ring-2 vai-ring-primary',
        className,
      )}
    >
      <input
        type="checkbox"
        className="vai-hidden"
        checked={checked}
        onChange={onChange}
      />
      {children}
      <SelectedOverlay visible={checked} />
    </label>
  );
};
